// extracted by mini-css-extract-plugin
export var alertIcon = "_qx-0";